import type { StoreApi, OpenDeleteIssueModalProps, EndDeleteIssueModalProps } from './types.tsx';

const noop = () => {
	return null;
};

export const DeleteIssueModalActions = {
	openDeleteIssueModal:
		({
			isIssueArchivalEnabled,
			workType,
			issueKey,
			issueId,
			onIssueDeleteSuccess,
			onIssueDeleteFailure,
			onTriggerDeleteRequest,
		}: OpenDeleteIssueModalProps) =>
		({ setState }: StoreApi) => {
			setState({
				isDeleteIssueModalOpen: true,
				isIssueArchivalEnabled,
				workType,
				issueKey,
				issueId,
				onIssueDeleteSuccess,
				onIssueDeleteFailure,
				onTriggerDeleteRequest,
			});
		},
	closeDeleteIssueModal:
		() =>
		({ setState }: StoreApi) => {
			setState({
				isDeleteIssueModalOpen: false,
				didIssueDeleteFail: false,
				isDeletingIssue: false,
				issueKey: '',
				issueId: '',
				isIssueArchivalEnabled: false,
				workType: null,
				onIssueDeleteSuccess: noop,
				onIssueDeleteFailure: noop,
				onTriggerDeleteRequest: noop,
			});
		},
	startDeleteIssue:
		() =>
		({ setState }: StoreApi) => {
			setState({ isDeletingIssue: true });
		},

	endDeleteIssue:
		({ didIssueDeleteFail }: EndDeleteIssueModalProps) =>
		({ setState }: StoreApi) => {
			setState({
				isDeletingIssue: false,
				didIssueDeleteFail,
			});
		},
};

export type Actions = typeof DeleteIssueModalActions;
